// extracted by mini-css-extract-plugin
export default {"container":"ChipGroup_container__0cr-B","required":"ChipGroup_required__GVi8T","chipGroup":"ChipGroup_chipGroup__Ewxoh","chipLabel":"ChipGroup_chipLabel__TttNG"};